<template>
  <section class="bg-indonesia">
    <svg width="0" height="0" class="hidden">
      <symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20.099 19.261" id="star">
        <path id="star-curved"
              d="M20.046,7.774a1.067,1.067,0,0,0-.919-.734l-5.8-.527L11.033,1.145a1.069,1.069,0,0,0-1.966,0L6.774,6.514l-5.8.527A1.07,1.07,0,0,0,.364,8.91L4.75,12.755l-1.293,5.7a1.068,1.068,0,0,0,1.59,1.155l5-2.992,5,2.992a1.069,1.069,0,0,0,1.591-1.155l-1.293-5.7L19.735,8.91a1.07,1.07,0,0,0,.312-1.136Zm-9.9,8.783"
              transform="translate(0 -0.496)"></path>
      </symbol>
    </svg>
    <div class="">
      <div class="relative w-full px-5 py-12 mx-auto overflow-hidden lg:px-14 xl:px-20 2xl:px-12 xl:py-14 2xl:py-20">
        <div class="flex flex-wrap items-start lg:items-center">
          <div class="w-full space-y-3.5 lg:space-y-5 pb-7 text-center mx-auto">
            <div class="flex items-center justify-center mx-auto space-x-2 text-gray-300">

              <div class="text-center">
                <!-- SVG Sprite -->
                <svg width="0" height="0" class="hidden">
                  <symbol fill="orange" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="star1">
                    <path
                        d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.536.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
                  </symbol>
                </svg>
                <p class="flex items-center justify-center mt-3 space-x-2 text-gray-300">
                  <svg class="w-5 h-5 icon">
                    <use xlink:href="#star1"></use>
                  </svg>
                  <svg class="w-6 h-6 icon">
                    <use xlink:href="#star1"></use>
                  </svg>
                  <svg class="w-7 h-7 icon">
                    <use xlink:href="#star1"></use>
                  </svg>
                  <svg class="w-6 h-6 icon">
                    <use xlink:href="#star1"></use>
                  </svg>
                  <svg class="w-5 h-5 icon">
                    <use xlink:href="#star1"></use>
                  </svg>
                </p>
                <div class="text-sm text-gray-500 downcase md:text-base lg:text-xl">
                  <strong role="heading"
                          class="font-bold text-gray-700 text-md md:text-base lg:text-xl">{{ allReviewsRating }}/5</strong>
                  based on
                  <strong class="font-bold text-gray-700 text-md md:text-base lg:text-xl">{{ allReviewsCount }}</strong>
                  reviews
                </div>
                <p></p>
              </div>

            </div>
          </div>
          <div
              class="flex flex-wrap justify-between px-2 pt-6 lg:pt-10 lg:-mx-4 xl:-mx-6 gap-y-8 xl:gap-y-14 2xl:gap-y-24">

            <div class="flex flex-col w-full px-2 md:w-1/2 lg:w-1/3 lg:px-4 xl:px-6" v-for="(item, index) in listItem">
              <div
                  class="flex flex-col items-center h-full px-6 py-6 text-center bg-white shadow-xl xl:px-9 space-y-7 rounded-lg">


                <div id="" class="lazy__container  aspect-auto">

                  <nuxt-img
                      class="mx-auto object-contain"
                      width="157"
                      height="157"
                      loading="lazy"
                      format="webp"
                      sizes="sm:157px  md:157vw lg:157vw xl:157px"
                      :alt="item.imageAlt"
                      :src="item.image"
                  ></nuxt-img>


                </div>


                <div class="flex items-center justify-center space-x-3">
                  <svg class="icon" width="20" height="20" fill="#FFA500">
                    <use xlink:href="#star"></use>
                  </svg>
                  <svg class="icon" width="20" height="20" fill="#FFA500">
                    <use xlink:href="#star"></use>
                  </svg>
                  <svg class="icon" width="20" height="20" fill="#FFA500">
                    <use xlink:href="#star"></use>
                  </svg>
                  <svg class="icon" width="20" height="20" fill="#FFA500">
                    <use xlink:href="#star"></use>
                  </svg>
                  <svg class="icon" width="20" height="20" fill="#FFA500">
                    <use xlink:href="#star"></use>
                  </svg>
                </div>
                <div class="text-center space-y-3.5">
                  <p class="text-base lg:text-xl font-ww-medium"></p>
                  <p class="text-lg textp" v-html="item.description"></p>
                  <p class="textp font-ww-medium" v-html="item.name"></p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>


const {data, error} = useFetch('https://lifebooxt.vercel.app/api/judgememedals')
const allReviewsRating = ref(0)
const allReviewsCount = ref(0)

if (!error.value) {
  allReviewsRating.value = data.value?.all_reviews_rating
  allReviewsCount.value = data.value?.all_reviews_count
}


defineProps({

  reviews: {
    type: String,
    default: '26296 Five-Star Reviews!',
  },
  title: {
    type: String,
    default: 'SEE WHAT CUSTOMERS <br> ARE SAYING…'
  },

  listItem: {
    type: Array,
    default: () => [
      {
        image: {
          type: String,
          default: 'assets/images/custo-1_120x300.png',
        },
        imageAlt: {
          type: String,
          default: 'image Shoshanda S. H.'
        },
        description: {
          type: String,
          default: 'This is the best coffee I have ever tasted. So delicious. This coffee lover is on a budget.'
        },
        name: {
          type: String,
          default: '- Shoshanda S. H.'
        }
      },
      {
        image: {
          type: String,
          default: 'assets/images/custo-2_120x300.png',
        },
        imageAlt: {
          type: String,
          default: 'image Nicole F'
        },
        description: {
          type: String,
          default: 'Wonderful, so gentle on my stomach. I can tell the difference between drinking this coffee versus other brands ❤️☕'
        },
        name: {
          type: String,
          default: '- Nicole F.'
        }
      },
      {
        image: {
          type: String,
          default: 'assets/images/custo-3_120x300.png',
        },
        imageAlt: {
          type: String,
          default: 'Laurie C'
        },
        description: {
          type: String,
          default: 'Very good coffee and I feel better knowing it’s free of pesticide.'
        },
        name: {
          type: String,
          default: '- Laurie C.'
        }
      },
      {
        image: {
          type: String,
          default: 'assets/images/custo-4_120x300.png',
        },
        imageAlt: {
          type: String,
          default: 'Michael B.'
        },
        description: {
          type: String,
          default: 'This coffee is definitely the best tasting I have ever had and so very smooth. No acidic taste at all. It does not upset my stomach at all, like all the other coffees did.'
        },
        name: {
          type: String,
          default: '- Michael B.'
        }
      },
      {
        image: {
          type: String,
          default: 'assets/images/custo-5_120x300.png',
        },
        imageAlt: {
          type: String,
          default: 'Cindy H'
        },
        description: {
          type: String,
          default: 'We absolutely LOVE this coffee. Don\'t think I\'ll be purchasing any other brand again.'
        },
        name: {
          type: String,
          default: '- Cindy H.'
        }
      },
      {
        image: {
          type: String,
          default: 'assets/images/custo-6_120x300.png',
        },
        imageAlt: {
          type: String,
          default: 'Ginger L.'
        },
        description: {
          type: String,
          default: 'Lifeboost coffee is the best tasting low acid coffee ever! And it’s great on your teeth!'
        },
        name: {
          type: String,
          default: '- Ginger L.'
        }
      },

    ],
  },


})

defineBuilderComponent({
    friendlyName: "Reviews",
    canHaveChildren: true,
    inputs: [
        {
            name: "reviews",
            type: "richText",
            defaultValue: "26296 Five-Star Reviews!"
        },
        {
            name: "title",
            type: "richText",
            defaultValue: "SEE WHAT CUSTOMERS <br> ARE SAYING…"
        },
        {
            name: "listItem",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png"
                    ]
                },
                {
                    name: "imageAlt",
                    type: "text"
                },
                {
                    name: "description",
                    type: "richText"
                },
                {
                    name: "name",
                    type: "richText"
                }
            ],
            defaultValue: [
                {
                    image: "assets/images/custo-1_120x300.png",
                    imageAlt: "image Shoshanda S. H.",
                    description: "This is the best coffee I have ever tasted. So delicious. This coffee lover is on a budget.",
                    name: "- Shoshanda S. H."
                },
                {
                    image: "assets/images/custo-2_120x300.png",
                    imageAlt: "image Nicole F",
                    description: "Wonderful, so gentle on my stomach. I can tell the difference between drinking this coffee versus other brands ❤️☕",
                    name: "- Nicole F."
                },
                {
                    image: "assets/images/custo-3_120x300.png",
                    imageAlt: "Laurie C",
                    description: "Very good coffee and I feel better knowing it’s free of pesticide.",
                    name: "- Laurie C."
                },
                {
                    image: "assets/images/custo-4_120x300.png",
                    imageAlt: "Michael B.",
                    description: "This coffee is definitely the best tasting I have ever had and so very smooth. No acidic taste at all. It does not upset my stomach at all, like all the other coffees did.",
                    name: "- Michael B."
                },
                {
                    image: "assets/images/custo-5_120x300.png",
                    imageAlt: "Cindy H",
                    description: "We absolutely LOVE this coffee. Don't think I'll be purchasing any other brand again.",
                    name: "- Cindy H."
                },
                {
                    image: "assets/images/custo-6_120x300.png",
                    imageAlt: "Ginger L.",
                    description: "Lifeboost coffee is the best tasting low acid coffee ever! And it’s great on your teeth!",
                    name: "- Ginger L."
                }
            ]
        }
    ]
});
</script>